import { ShieldAlert, AlertTriangle, CheckCircle2 } from "lucide-react";
import { RULE_LABELS } from "@/lib/status";

function Row({ issue, tone }) {
  const isBlock = tone === "block";
  const Icon = isBlock ? ShieldAlert : AlertTriangle;
  const color = isBlock ? "#991B1B" : "#92400E";
  const bg = isBlock ? "#FEF2F2" : "#FFFBEB";
  const border = isBlock ? "#FCA5A5" : "#FDE68A";
  return (
    <div
      className="flex gap-2.5 rounded-md p-2.5"
      style={{ backgroundColor: bg, border: `1px solid ${border}` }}
      data-testid={`conflict-${issue.code}`}
    >
      <Icon className="h-4 w-4 shrink-0 mt-0.5" style={{ color }} />
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-bold uppercase tracking-wider" style={{ color }}>
            {RULE_LABELS[issue.code] || issue.code}
          </span>
        </div>
        <p className="text-xs text-slate-700 mt-0.5 leading-snug">{issue.message}</p>
        {issue.detail && <p className="text-[11px] text-slate-500 mt-0.5">{issue.detail}</p>}
      </div>
    </div>
  );
}

export function ConflictPanel({ conflicts }) {
  if (!conflicts) return null;
  const { blocks = [], warnings = [] } = conflicts;
  if (blocks.length === 0 && warnings.length === 0) {
    return (
      <div className="flex items-center gap-2 rounded-md p-2.5 bg-emerald-50 border border-emerald-200" data-testid="conflict-clear">
        <CheckCircle2 className="h-4 w-4 text-emerald-600" />
        <span className="text-xs text-emerald-800 font-medium">No conflicts detected — clear to publish.</span>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="conflict-panel">
      {blocks.length > 0 && (
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold uppercase tracking-wider text-red-700">
              Hard Blocks ({blocks.length})
            </span>
            <span className="text-[10px] text-slate-400">— prevent publish unless overridden</span>
          </div>
          {blocks.map((b, i) => <Row key={i} issue={b} tone="block" />)}
        </div>
      )}
      {warnings.length > 0 && (
        <div className="space-y-1.5">
          <span className="text-[10px] font-bold uppercase tracking-wider text-amber-700">
            Warnings ({warnings.length})
          </span>
          {warnings.map((w, i) => <Row key={i} issue={w} tone="warning" />)}
        </div>
      )}
    </div>
  );
}
